export const ATTACHMENT_LIMIT_PER_FOLDER = 15
export const MAX_VISIBLE_ATTACHMENTS = 10
export const ATTACHMENT_LIMIT_TOOLTIP_TEXT = `You've reached the limit of ${ATTACHMENT_LIMIT_PER_FOLDER} attachments for this folder.`
export const ATTACHMENT_LIMIT_ARIA_DESCRIPTION = `You cannot add more attachments. This folder already has ${ATTACHMENT_LIMIT_PER_FOLDER} attachments.`
